"use client";

export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div
      dir="rtl"
      className="flex flex-col items-center justify-center min-h-screen gap-4 p-8 text-center bg-th-bg"
    >
      <div className="text-5xl">⚠️</div>
      <h2 className="text-xl font-bold text-th-text">حدث خطأ</h2>
      <p className="text-sm text-th-text-muted">
        {error.message || "يرجى المحاولة مرةً أخرى."}
      </p>
      <button
        onClick={reset}
        className="px-6 py-2 bg-accent-700 text-accent-foreground rounded-lg hover:bg-accent-800 transition-colors"
      >
        إعادة المحاولة
      </button>
    </div>
  );
}
